"use strict";
import { ensure0xHex, isValidHexString, numberToHex } from "uniswap/src/utils/hex";
export function ensureValidatedCapabilities(data) {
  if (!isValidCapabilitiesObject(data)) {
    return null;
  }
  const result = {};
  for (const [rawChainId, capabilities] of Object.entries(data)) {
    if (!isValidCapabilitiesEntry(capabilities)) {
      return null;
    }
    const normalizedChainId = normalizeChainId(rawChainId);
    if (!normalizedChainId) {
      return null;
    }
    result[normalizedChainId] = capabilities;
  }
  return result;
}
export function isValidCapabilitiesObject(data) {
  return Boolean(data) && typeof data === "object" && !Array.isArray(data);
}
export function isValidCapabilitiesEntry(entry) {
  if (!entry || typeof entry !== "object" || Array.isArray(entry)) {
    return false;
  }
  return true;
}
function normalizeChainId(chainId) {
  if (isValidHexString(chainId)) {
    return chainId;
  }
  const chainIdNumber = Number(chainId);
  if (isNaN(chainIdNumber)) {
    return null;
  }
  return ensure0xHex(numberToHex(chainIdNumber));
}
